import React, { Suspense } from 'react'
import PropTypes from 'prop-types'

/**
 * @prop {Element} feature - Feature component
 * @prop {Element} fallback - Fallback component to render in case feature is not enabled
 * @prop {Element} loader - Loader component to render while feature is not loaded
 * @prop {*} props - All others props passed
 */
const ToggleFeature = ({
  feature: Feature = null,
  fallback: Fallback = null,
  default: Default = null,
  customValidation = true,
  ...props
}) => {
  if (Feature && customValidation) {
    return (
      <Suspense fallback={Fallback ? <Fallback /> : <div />}>
        <Feature {...props} />
      </Suspense>
    )
  } else {
    return Default && <Default {...props} />
  }
}

ToggleFeature.propTypes = {
  feature: PropTypes.object,
  fallback: PropTypes.object,
  default: PropTypes.object,
  customValidation: PropTypes.bool
}

export default ToggleFeature



// WEBPACK FOOTER //
// ./src/features/ToggleFeature/ToggleFeature.js